module.exports = __webpack_public_path__ + "img/2.6a0c693c.png";